import React from 'react';
import Component from "./Component";
import TextInput from '../../components/form/TextInput';
import STRINGS from './../../data/language/language';

const CLASS_SEXO_PLANILHA = " planilha-detalhe ";
const CLASS_REFERENCE = "tipo-planilha-";

export default class FormSexo extends React.Component {
  constructor (props){
    super(props);

    this.state = {
      id:props.id,
      ativo:0,
      dados:props.data,
      strings:STRINGS[window.LANGUAGE],
    }
  }

  render(){
    const {
      dataInicio,
      dataFim,
      treinoDomiciliar,
      nomeTreinoDomiciliar,
      observacoes,
      salvar,
      digiteAqui,
      sexo,
      circuito,
      repeticoes,
      cadenciaTitle,
      sessoes
    } = this.state.strings;

    const circuitoVal = this.state.dados.circuito;
    const repeticoesVal = this.state.dados.repeticoes;
    const sessoesVal = this.state.dados.sessoes;
    const cadenciaVal =this.state.dados.cadencia;

    let _id = this.state.id;
    let _classes = CLASS_SEXO_PLANILHA+(this.props.ativo ? "ativo" : "");

    return(
      <div className={_classes} id={_id} data-id={this.props.identifier}>
        <div className="pure-u-6-24">
          <TextInput
            name="circuito"
            title={circuito}
            placeholder={digiteAqui}
            value={circuitoVal}
          />
        </div>
        <div className="pure-u-6-24">
          <TextInput
            name="repeticoes"
            title={repeticoes}
            placeholder={digiteAqui}
            value={repeticoesVal}
          />
        </div>
        <div className="pure-u-6-24">
          <TextInput
            name="sessoes"
            title={sessoes}
            placeholder={digiteAqui}
            value={sessoesVal}
          />
        </div>
        <div className="pure-u-6-24">
          <TextInput
            name="cadencia"
            title={cadenciaTitle}
            placeholder={digiteAqui}
            value={cadenciaVal}
          />
        </div>
        <Component
          sexo={this.props.sexo}
          wrapper={this.state.wrapper}
          detalhe={this.state.dados}
        />
        <br/><br/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/treino-domiciliar/FormSexo.js